// Generated by ReScript, PLEASE EDIT WITH CARE


var Config = {
  jello: {
    mass: 1,
    tension: 200,
    friction: 8
  }
};

var Animated = {};

export {
  Config ,
  Animated ,
  
}
/* No side effect */
